import { c as createToastInstance, a as closeById, b as closeAllNotifications } from "../toast-1e0d9ebf.mjs";
import { u as useAppContext } from "../../../composables/useAppContext-4f7613f2.mjs";
const useToast = () => {
  const appContext = useAppContext();
  const createdInThisSetupContext = [];
  const init = (options) => {
    const id = createToastInstance(options, appContext.value);
    if (id) {
      createdInThisSetupContext.push(id);
    }
    return id;
  };
  const close = (id) => closeById(id);
  const closeAll = (allApps = false) => closeAllNotifications(allApps ? void 0 : appContext.value);
  const closeAllCreatedInThisHook = () => {
    createdInThisSetupContext.forEach((id) => closeById(id));
  };
  return {
    init,
    close,
    closeAll,
    closeAllCreatedInThisHook
  };
};
export {
  useToast as u
};
//# sourceMappingURL=useToast-81996c9c.mjs.map
